import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllAdvertisersForAnalyticsSearch.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useAllAdvertisersForAnalyticsSearchQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllAdvertisersForAnalyticsSearchLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & {
  getAllAdvertisersForAnalyticsSearchQuery: LazyQueryExecFunction<Query, OperationVariables>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getAllAdvertisersForAnalyticsSearch
  const [getAllAdvertisersForAnalyticsSearchQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllAdvertisersForAnalyticsSearchQuery, ...result };
};

export const useAllAdvertisersForAnalyticsSearchPromiseQuery = () => {
  const client = useApolloClient();

  const getAllAdvertisersForAnalyticsSearch = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllAdvertisersForAnalyticsSearch };
};
